<script>
export default {
  props: {
    woData: {
      type: Object,
      default() {
        return {}
      }
    },
  }
}
</script>
<template>
  <b-card no-body>
    <b-card-header>
      <div class="d-sm-flex align-items-center">
        <h5 class="card-title flex-grow-1 mb-0">工单日志</h5>
      </div>
    </b-card-header>
    <b-card-body>
      <div class="profile-timeline">
        <div class="accordion accordion-flush">
          <div class="accordion-item border-0">
            <div class="accordion-header">
              <b-link class="accordion-button p-2 shadow-none" data-bs-toggle="collapse"
                      aria-expanded="false">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 avatar-xs">
                    <div class="avatar-title bg-success text-white rounded-circle">
                      <span>张</span>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h6 class="fs-14 mb-0 fw-semibold">
                      创建工单
                    </h6>
                    <div class="text-muted mt-2 fw-normal">张涛创建了工单</div>
                    <div class="text-muted mt-2 fw-normal">2023/01/01 14:23:35</div>
                  </div>
                </div>
              </b-link>
            </div>
          </div>

          <div class="accordion-item border-0">
            <div class="accordion-header">
              <b-link class="accordion-button p-2 shadow-none" data-bs-toggle="collapse"
                      aria-expanded="false">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 avatar-xs">
                    <div class="avatar-title bg-success text-white rounded-circle">
                      <span>张</span>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h6 class="fs-14 mb-0 fw-semibold">
                      创建工单
                    </h6>
                    <div class="text-muted mt-2 fw-normal">张涛创建了工单</div>
                    <div class="text-muted mt-2 fw-normal">2023/01/01 14:23:35</div>
                  </div>
                </div>
              </b-link>
            </div>
          </div>

          <div class="accordion-item border-0">
            <div class="accordion-header">
              <b-link class="accordion-button p-2 shadow-none" data-bs-toggle="collapse"
                      aria-expanded="false">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 avatar-xs">
                    <div class="avatar-title bg-success text-white rounded-circle">
                      <span>张</span>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h6 class="fs-14 mb-0 fw-semibold">
                      创建工单
                    </h6>
                    <div class="text-muted mt-2 fw-normal">张涛创建了工单</div>
                    <div class="mt-2">
                      <img src="@/assets/images/normal_u41.png" class="me-2">
                      <img src="@/assets/images/normal_u41.png" class="me-2">
                      <img src="@/assets/images/normal_u41.png" class="me-2">
                    </div>
                    <div class="text-muted mt-2 fw-normal">2023/01/01 14:23:35</div>
                  </div>
                </div>
              </b-link>
            </div>
          </div>

          <div class="accordion-item border-0">
            <div class="accordion-header">
              <b-link class="accordion-button p-2 shadow-none" data-bs-toggle="collapse"
                      aria-expanded="false">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 avatar-xs">
                    <div class="avatar-title bg-success text-white rounded-circle">
                      <span>张</span>
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h6 class="fs-14 mb-0 fw-semibold">
                      创建工单
                    </h6>
                    <div class="text-muted mt-2 fw-normal">张涛创建了工单</div>
                    <div class="text-muted mt-2 fw-normal">2023/01/01 14:23:35</div>
                  </div>
                </div>
              </b-link>
            </div>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
